<template>
  <div @click="addInWishlist" class="favorite" :class="{ 'favorite--active': active }">
    <IconComponent name="heart-fill" />
  </div>
</template>

<script>
import IconComponent from "components/IconComponent.vue";
import AuthorizationModal from "components/modal/components/AuthorizationModal.vue";
import POST from "@/graphql/mutations/FavoriteCreateOrDelete.graphql";
export default {
  name: "FavoriteComponent",
  components: { IconComponent },
  props: {
    product: {
      type: Object,
    },
  },
  data() {
    return {
      debounce: null,
    };
  },
  methods: {
    addInWishlist() {
      if (this.isRegistered) {
        // если товар уже в избранном то удаляем
        if (this.active) {
          this.$store.state.auth.favoritesItems = this.$store.state.auth.favoritesItems.filter((item) => {
            return item.id !== this.product.id;
          });
        } else {
          // если нет то сохраняем
          this.$store.state.auth.favoritesItems.push(this.product);
        }
        if (this.debounce) {
          clearTimeout(this.debounce);
        }
        this.debounce = setTimeout(() => {
          this.$apollo
            .mutate({
              mutation: POST,
              context: {
                headers: {
                  Authorization: "Bearer " + this.$store.state.apollo_token,
                },
              },
              variables: {
                id: this.product.id,
              },
            })
            .then(() => {
              this.$store.dispatch("USER", {
                apollo: this.$apollo.provider,
              });
            })
            .catch(() => {});
        }, 500);
      } else {
        this.$store.state._modals.push({
          component: AuthorizationModal,
        });
      }
    },
  },
  computed: {
    active() {
      return this.$store.state.auth.favoritesItems
        ? this.$store.state.auth.favoritesItems.find((item) => {
            return item.id === this.product.id;
          })
        : false;
    },
    isRegistered() {
      return this.$store.state.auth.user ? this.$store.state.auth.user.is_authorized : null;
    },
  },
};
</script>

<style lang="stylus">
.favorite {
  display flex
  align-items center
  justify-content center
  width 30px
  height 30px
  background var(--gray-2)
  transition var(--transition)
  cursor pointer
  border-radius 40px

  &--active {
    background var(--red)
  }

  &:hover {
    background var(--red)
  }
  .icon svg {
    height  13px
    width 13px
  }

  +below(1024px) {
    width 25px
    height 25px
  }
}
</style>
